var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCyclicalArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.35114L15.2114 11.1282L13.4228 9.35114",
    stroke: "#7036AE",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.88838L2.78789 6.11202L4.57578 7.88838",
    stroke: "#7036AE",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2114 11.2166L15.2255 8.61609C15.2255 5.18304 12.4244 2.4 8.96906 2.4C7.66429 2.4 6.4528 2.79684 5.4502 3.47566",
    stroke: "#7036AE",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5634 13.7245C11.5608 14.4034 10.3493 14.8002 9.0445 14.8002C5.58918 14.8002 2.78809 12.0172 2.78809 8.58412V5.92644V5.92644",
    stroke: "#7036AE",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyclicalArrows);
export default __webpack_public_path__ + "static/media/cyclical-arrows.f084df0add85fd9028ef56c967b44730.svg";
export { ForwardRef as ReactComponent };